var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "h-100", attrs: { id: "app" } },
    [
      _c("el-header", { staticClass: "px-0", attrs: { height: "" } }, [
        _c(
          "nav",
          {
            staticClass:
              "bg-primary navbar navbar-dark navbar-expand sticky-top"
          },
          [
            _c(
              "a",
              {
                staticClass: "navbar-brand",
                attrs: {
                  href: "https://github.com/stefanwimmer128/core",
                  target: "_blank"
                }
              },
              [
                _c("img", {
                  staticClass: "align-top d-inline-block",
                  attrs: { src: require("../images/github.png") }
                }),
                _vm._v(" @stefanwimmer128/core")
              ]
            ),
            _c(
              "div",
              { staticClass: "navbar-nav" },
              [
                _c(
                  "router-link",
                  { staticClass: "nav-item nav-link", attrs: { to: "/" } },
                  [_vm._v("Home")]
                ),
                _c(
                  "router-link",
                  { staticClass: "nav-item nav-link", attrs: { to: "/docs" } },
                  [_vm._v("API documentation")]
                )
              ],
              1
            )
          ]
        )
      ]),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c0a0fc1", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0a0fc1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app.vue
// module id = 759
// module chunks = 0